import { useParams, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LoadingSpinner } from "@/components/LoadingSpinner";
import MentorProfile from "./MentorProfile";

const MentorSlugProfile = () => {
  const { slug } = useParams<{ slug: string }>();
  const [mentorId, setMentorId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchMentorBySlug = async () => {
      if (!slug) {
        setNotFound(true);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('mentors')
          .select('id')
          .eq('url_slug', slug.toLowerCase())
          .eq('is_active', true)
          .eq('is_approved', true)
          .single();

        if (error || !data) {
          setNotFound(true);
        } else {
          setMentorId(data.id);
        }
      } catch (err) {
        console.error('Error fetching mentor by slug:', err);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    fetchMentorBySlug();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (notFound) {
    return <Navigate to="/not-found" replace />;
  }

  // Render MentorProfile with the resolved mentorId
  // We pass key to force remount when mentorId changes
  return <MentorProfile key={mentorId} overrideMentorId={mentorId!} />;
};

export default MentorSlugProfile;
